/* global ADV */
function handleLegacyRoutingEvents(event) {
  const { target: rawTarget } = event;

  for (let target = rawTarget; target && target !== this; target = target.parentNode) {
    const isDataAction = target.matches('[data-action]');
    const isDataRoute = target.matches('[data-route]');

    if (isDataAction || isDataRoute) {
      event.preventDefault();

      if (target.classList.contains('locked')) {
        return;
      }

      if (isDataAction) {
        const action = target.getAttribute('data-action');
        const params = target.getAttribute('data-params');

        if (ADV.Controller[action]) {
          ADV.Controller[action](params);
        }
      }

      if (isDataRoute) {
        const route = target.getAttribute('data-route');
        const routeObj = ADV.util.Router.getObjFromHash(route);

        if (routeObj) {
          ADV.util.Router.go2(routeObj.id, routeObj.params);
        }
      }
    }
  }
}

export default handleLegacyRoutingEvents;
